import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

function initRecentlyViewedPdp() {
  const root = document.querySelector('[data-ash-recently-viewed]');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const currentId = root.dataset.productId;
  const max = Number(root.dataset.maxItems || 6);

  const ids = RecentlyViewed.getProducts()
    .filter((id) => id !== currentId)
    .slice(0, max);

  if (ids.length === 0) return;

  const url = new URL(window.Shopify?.routes?.search_url || '/search', window.location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('resources[type]', 'product');

  sectionRenderer
    .getSectionHTML(sectionId, false, url)
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-ash-recently-viewed]');
      const scroller = root.querySelector('[data-ash-rv-scroller]');
      const freshScroller = fresh?.querySelector('[data-ash-rv-scroller]');
      if (!scroller || !freshScroller || !freshScroller.children.length) return;
      scroller.replaceChildren(...freshScroller.children);
      root.hidden = false;
    })
    .catch(() => {
      /* keep hidden */
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewedPdp);
} else {
  initRecentlyViewedPdp();
}
